import { render, staticRenderFns } from "./Applets.vue?vue&type=template&id=5c770332&scoped=true"
import script from "./Applets.vue?vue&type=script&lang=js"
export * from "./Applets.vue?vue&type=script&lang=js"
import style0 from "./Applets.vue?vue&type=style&index=0&id=5c770332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c770332",
  null
  
)

export default component.exports